const DotGrid = ({ cols = 3, dotR = 1.2, gap = 4 }) => {
  const rows = 2;
  const step = dotR * 2 + gap;
  const width = cols * step;
  const height = rows * step;
  const dots = [];

  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      dots.push(
        <circle
          key={`${r}-${c}`}
          cx={c * step + step / 2}
          cy={r * step + step / 2}
          r={dotR}
        />
      );
    }
  }

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="currentColor">
      {dots}
    </svg>
  );
};

export default DotGrid;
